import * as React from 'react'
import { Button } from '@components'
import type { CampaignItemCardProps } from './CampaignItem.types'
import { useFormatCurrency } from './CampaignItem.hooks'
import { useContentConfig } from '@core/hooks'
import { cn } from '@core/utils'

const CampaignItemCard: React.FC<CampaignItemCardProps> = ({
    type,
    image,
    isUsed,
    showPercentSuffix = true,
    point,
    percent,
    currency,
    description,
    className,
    actionButtonClick,
}) => {
    const content = useContentConfig()
    const { currencySymbol, formattedText } = useFormatCurrency(point, currency)

    const formattedPercent = React.useMemo(() => {
        return percent ? `${percent}%` : ''
    }, [percent])

    const suffixLabel = React.useMemo(() => {
        return percent && showPercentSuffix
            ? content.campaignItem.percentSuffix
            : content.campaignItem.pointSuffix
    }, [
        content.campaignItem.percentSuffix,
        content.campaignItem.pointSuffix,
        percent,
        showPercentSuffix,
    ])

    return (
        <div
            className={cn('campaign-item-card__container h-[220px]', className)}
            style={{ backgroundImage: `url(${image})` }}>
            <div data-is-used={isUsed} className="campaign-item-card">
                <div className="campaign-item-card__content">
                    {type === 'percentage' && (
                        <div className="campaign-item-card__content__point">
                            <span>{formattedPercent}</span>
                            <span>{suffixLabel}</span>
                        </div>
                    )}
                    {type === 'fixed' && (
                        <div className="campaign-item-card__content__point">
                            <span>{currencySymbol + formattedText}</span>
                            <span>{suffixLabel}</span>
                        </div>
                    )}
                    <p>{description}</p>
                </div>
                <Button
                    className="w-full"
                    children={
                        isUsed
                            ? content.campaignItem.disabledButtonText
                            : content.campaignItem.detailsButtonText
                    }
                    variant={!isUsed ? 'primary' : 'used'}
                    rounded="pill"
                    size="tiny"
                    onClick={actionButtonClick}
                />
            </div>
        </div>
    )
}
CampaignItemCard.displayName = 'CampaignItemCard'

export default CampaignItemCard
